export default __webpack_public_path__ + "static/media/Valentpath.ed66c1f0.png";